import { fetchFactory } from '../../../utils/fetchFactory'

export const getUserByEmail = (): Promise<MustUserResponse> => {
	return fetchFactory(`/api/admin/mustuser/email`, { method: 'POST' })
}

export const getIsUser = (): Promise<any> => fetchFactory(`/auth/user`)